(() => {
  "use strict";

  const USER_CHOICE_ATTRIBUTE = "data-ampm-purchase-choice";
  const SUBI_WRAPPER_SELECTOR = ".subify-app-block-wrapper";
  const SUBI_OPTION_SELECTOR = ".subify-minimal-option";
  const NATIVE_WIDGET_SELECTOR = "sub-widget";
  const NATIVE_PLAN_SELECTOR = ".wt-subscription-widget__plans";
  const PAID_OPTIONS_SELECTOR = ".ampm-paid-landing__purchase-options";

  // The shareable discount link retains this UTM tag through Shopify's redirect.
  const isCreatineBundleEntry = window.location.pathname.replace(/\/$/, "").endsWith("/products/creatine-monohydrate-electrolyte-gummies") &&
    new URLSearchParams(window.location.search).get("utm_term") === "creatine_3for2_product_page";
  let offerQuantityApplied = false;
  const dismissedWelcomeForms = new WeakSet();
  const dismissConflictingWelcomeOffer = () => {
    if (!isCreatineBundleEntry) return;
    document.querySelectorAll('[role="dialog"]').forEach((dialog) => {
      if (dialog.getAttribute("aria-label") !== "AM:PM welcome offer and email signup" || dismissedWelcomeForms.has(dialog)) return;
      const closeButton = dialog.querySelector('button[aria-label="Close dialog"]');
      if (!closeButton) return;
      dismissedWelcomeForms.add(dialog);
      closeButton.click();
    });
  };
  const applyOfferQuantity = () => {
    if (!isCreatineBundleEntry || offerQuantityApplied) return;
    const quantity = document.querySelector('[data-ampm-core-product] input[name="quantity"]');
    if (!quantity) return;
    offerQuantityApplied = true;
    quantity.defaultValue = "3";
    quantity.value = "3";
    quantity.dispatchEvent(new Event("input", { bubbles: true }));
    quantity.dispatchEvent(new Event("change", { bubbles: true }));
  };
  let applyFrame;

  const hasUserChoice = (element) =>
    element?.getAttribute(USER_CHOICE_ATTRIBUTE) === "true";

  const markUserChoice = (element) => {
    if (element) element.setAttribute(USER_CHOICE_ATTRIBUTE, "true");
  };

  const selectSubiSubscription = (wrapper) => {
    if (hasUserChoice(wrapper)) return;

    const options = [...wrapper.querySelectorAll(SUBI_OPTION_SELECTOR)];
    const subscriptionOption = options.find(
      (option) => isCreatineBundleEntry ? option.classList.contains("one-time-purchase-option") : !option.classList.contains("one-time-purchase-option"),
    );

    if (
      !subscriptionOption ||
      subscriptionOption.classList.contains("active") ||
      subscriptionOption.disabled
    ) {
      return;
    }

    const control =
      subscriptionOption.querySelector(".subify-minimal-radio") ||
      subscriptionOption;
    control.click();
  };

  const selectNativeSubscription = (widget) => {
    if (hasUserChoice(widget)) return;

    const subscriptionPlan = [...widget.querySelectorAll(NATIVE_PLAN_SELECTOR)].find(
      (plan) =>
        (isCreatineBundleEntry ? plan.id === "single-purchase-plan" : plan.id !== "single-purchase-plan") &&
        !plan.classList.contains("wt-subscription-widget__plans--disabled"),
    );

    if (
      subscriptionPlan &&
      !subscriptionPlan.classList.contains(
        "wt-subscription-widget__plans--selected",
      )
    ) {
      subscriptionPlan.click();
    }
  };

  const selectPaidLandingSubscription = (options) => {
    if (hasUserChoice(options)) return;

    const subscriptionInput = options.querySelector(
      'input[data-purchase-type="subscription"], input[value="subscription"]',
    );

    if (
      subscriptionInput &&
      !subscriptionInput.checked &&
      !subscriptionInput.disabled
    ) {
      subscriptionInput.click();
    }
  };

  const applySubscriptionDefaults = () => {
    applyOfferQuantity();
    dismissConflictingWelcomeOffer();
    document
      .querySelectorAll(SUBI_WRAPPER_SELECTOR)
      .forEach(selectSubiSubscription);
    document
      .querySelectorAll(NATIVE_WIDGET_SELECTOR)
      .forEach(selectNativeSubscription);
    document
      .querySelectorAll(PAID_OPTIONS_SELECTOR)
      .forEach(selectPaidLandingSubscription);
  };

  const scheduleDefaults = () => {
    window.cancelAnimationFrame(applyFrame);
    applyFrame = window.requestAnimationFrame(applySubscriptionDefaults);
  };

  document.addEventListener(
    "click",
    (event) => {
      if (!event.isTrusted || !(event.target instanceof Element)) return;

      const subiOption = event.target.closest(SUBI_OPTION_SELECTOR);
      if (subiOption) {
        markUserChoice(subiOption.closest(SUBI_WRAPPER_SELECTOR));
        return;
      }

      const nativePlan = event.target.closest(NATIVE_PLAN_SELECTOR);
      if (nativePlan) {
        markUserChoice(nativePlan.closest(NATIVE_WIDGET_SELECTOR));
        return;
      }

      const paidOption = event.target.closest(PAID_OPTIONS_SELECTOR);
      if (paidOption) markUserChoice(paidOption);
    },
    true,
  );

  const observer = new MutationObserver(scheduleDefaults);

  const initialise = () => {
    applySubscriptionDefaults();
    observer.observe(document.body, { childList: true, subtree: true });

    [250, 1000, 2500].forEach((delay) => {
      window.setTimeout(scheduleDefaults, delay);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise, { once: true });
  } else {
    initialise();
  }

  window.addEventListener("subify:sdkLoaded", scheduleDefaults);
  document.addEventListener("shopify:section:load", scheduleDefaults);
})();
